import React from 'react';
import CalibradorArte from '../shared/CalibradorArte';

export default function CalibrarEntrada() {
  return <CalibradorArte tipo="entrada" />;
}
